export default __webpack_public_path__ + "static/media/pumpkin.ec5dab54.gif";